export function ptlProductValidate(product){
    var result = true;

    result = validateProductId(product.product_id);
    result = validateBarcode(product.barcode);
    result = validateDescription(product.description);
    result = validateQuantity(product.quantity);
    result = validateWarehouseId(product.warehouse_id);
    result = validateLocations(product.locations);

    return result;
}

function validateProductId(product_id){    
    if(Number.isInteger(product_id)) return true;
    else return false;
}

function validateDescription(description){
    if(typeof description === 'string' || description.trim() !== '') return true;
    else return false;
}

function validateBarcode(barcode){
    if(barcode == null || typeof barcode === 'string' || barcode.trim() !== '') return true;
    else return false;
}

function validateQuantity(quantity) {
    if(/^([1-9]\d*|0)(\.\d+)?$/.test(quantity)) return true;
    else {
        return false;
    }
}

function validateWarehouseId(warehouse_id){    
    if(Number.isInteger(warehouse_id)) return true;
    else return false;
}

function validateLocations(locations){
    return Array.isArray(locations) 
        && locations.length > 0 
        && locations.every(item =>
        typeof item === 'object' &&
        item !== null &&
        typeof item.detailed_stock_id === 'number' && !isNaN(item.detailed_stock_id) &&
        typeof item.location_id === 'number' && !isNaN(item.location_id) &&
        typeof item.location === 'string' && item.location.trim() != "" &&
        typeof item.barcode === 'string' && item.barcode.trim() != "" &&
        typeof item.discount === 'number' && !isNaN(item.discount) &&
        typeof item.pallet === 'number' && !isNaN(item.pallet)
    );
}